import { useTranslations } from "next-intl";

import { cn } from "@/utils/cn";

interface CompletedDateProps {
  quartal: number;
  year: number;
  className?: string;
}

export const CompletedDate = ({
  quartal,
  year,
  className,
}: CompletedDateProps) => {
  const t = useTranslations();
  return (
    <span className={cn("text-sm text-gray-1100", className)}>
      {t("templates.completed", { quartal, year })}
    </span>
  );
};
